<div *ngIf="privateLesson?.code || loading()">
  <lx-card-container
    type="private-lesson"
    [loading]="loading()"
    i18n-title
    title="Private lessons"
    [weeks]="units"
    [disabled]="units === 0"
    [duration]="duration$ | async"
    [endPrice]="endPrice"
    [price]="price"
    [discount]="discount"
    [currency]="currency?.()"
    [attr.data-qa]="'privateLesson_card'"
    (changedWeeks)="setWeeksChanges($event)"
  >
    <div class="private-lesson__paragraph" i18n>
      Take advantage of 5 additional private lessons per week to achieve rapid progress. Private lessons can only be combined with the Standard course.
    </div>
  </lx-card-container>
</div>
